import { Image } from "antd";
import styles from "./OrderFromTo.module.scss";
import img_1 from "../../images/ic_current.png";
import ic_pin from "../../images/ic_pin.png";
import img_2 from "../../images/Line 2.png";
import { css } from "@emotion/css";
import cls from "classnames";


function OrderFromTo({ title, children }) {
  const titleFirst = title.split(" ").slice(0, -1).join(" ");
  const titleLast = title.split(" ").slice(-1).join(" ");
  const color_primary = "#612166"; // Replace with your primary color
  const color_secondary = "#294151"; // Replace with your secondary color
  const heading_primary  = css`
            font-size: 3rem;
            font-weight: 600;
            line-height: 1.63;
            letter-spacing: 0.48px;
            color: ${color_secondary};
            text-align: center;
            text-transform: capitalize;
            margin-bottom: 3rem;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;

            &:lang(ar) {
              flex-direction: row-reverse;
            }
            &.left {
              text-align: left;
              justify-content: flex-start;
              &:lang(ar) {
                justify-content: flex-end;
              }
            }
            .color {
              color: ${color_primary};
              // padding-left: 5px;
            }

            &.small {
              font-size: 4rem;
            }`;
  return (
    <div className={styles.order_from_to_wrapper}>
      <h2 className={cls("heading-primary left lang-ltr", heading_primary)}>
        <span>{titleFirst}</span>
        <span className="color">{titleLast}</span>
      </h2>
      <div className={styles.from_to_content}>
        <div className={styles.diagram}>
          <div className={styles.logo_holder}>
            <Image src={img_1} alt="img" preview={false} />
          </div>
          <div className={styles.line_holder}>
            <Image src={img_2} alt="img" preview={false} />
          </div>
          <div className={styles.logo_holder}>
            <Image src={ic_pin} alt="img" preview={false} />
          </div>
        </div>
        <div className={styles.inputs_holder}>{children}</div>
      </div>
    </div>
  );
}

export default OrderFromTo;
